import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../../../environments/environment";
// import { log } from "console";

@Component({
  selector: "app-college-university-list",
  templateUrl: "./college-university-list.component.html",
  styleUrls: ["./college-university-list.component.scss"],
})
export class CollegeUniversityListComponent implements OnInit {
  public list = [];
  message = null;
  class = null;
  handleError = null;

  constructor(private router: Router, private http: HttpClient) {}

  public settings = {
    actions: {
      position: "right",
      add: false,
      edit: false,
      delete: localStorage.getItem("userRole") == "admin" ? true : false,
    },
    delete: {
      confirmDelete: true,
    },
   columns: {
  collegeName: {   // key must match your flattened property
    title: "College",
  },
  universityName: {
    title: "University",
  },
/*   _id: {
    title: "Edit",
    type: "html",
    valuePrepareFunction: (cell, row) => {
      return `<a href="college-details/edit-college-university/${row._id}" class="ng2-smart-action"><i class="fa fa-pencil"></i></a>`;
    },
    filter: false,
  }, */
   _id: {
        title: "Edit",
        type: "html",
        valuePrepareFunction: (cell, row) => {
          return `<a href="college-details/edit-college-university/${row._id}"  class="ng2-smart-action ng2-smart-action-edit-edit ng-star-inserted"><i class="fa fa-pencil"></i></a>&nbsp; 
         `;
        },
        filter: false,
      },
},


  };

ngOnInit() {
  let role = localStorage.getItem("userRole");
  let user = localStorage.getItem("userId");
  const headers = {
    Userinfo: JSON.stringify({
      _id: localStorage.getItem("adminSess"),
      role: localStorage.getItem("userRole"),
    }),
  };

  const processList = (data) => {
    // flatten nested objects
    this.list = data.results.map(item => ({
      ...item,
      collegeName: item.collegeDetails ? item.collegeDetails.collegename : '-',
      universityName: item.universityDetails ? item.universityDetails.name : '-'
    }));
  };

  if (role == "admin") {
    this.http.get<any>(`${environment.apiUrl}/collegeuniversitydetails/`, { headers })
      .subscribe(data => {
        if(data.message === "Logged Out!") this.router.navigateByUrl("/auth/login");
        processList(data);
        console.log(this.list);
      }, this.handleError);
  } else {
    this.http.get<any>(`${environment.apiUrl}/collegeuniversitydetails/${user}`, { headers })
      .subscribe(data => {
        if(data.message === "Logged Out!") this.router.navigateByUrl("/auth/login");
        processList(data.data);
      }, this.handleError);
  }
}


  deleteRecord(event) {
    if (confirm("Are You Sure?")) {
      this.http
        .delete<any>(`${environment.apiUrl}/collegeuniversitydetails/${event.data._id}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            data.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (data.status == "500") {
              this.message = data.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Deleted";
              this.class = "btn-success rounded px-1 py-1";
              this.ngOnInit();
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    }
  }
}
